// Layout raíz del Dashboard JMA AFAC.
//
// Guard de sesión:
//   'loading'      → MSAL aún inicializándose.
//   'login'        → No hay sesión; mostrar LoginScreen.
//   'unauthorized' → Login OK pero correo fuera de la lista blanca.
//   'authorized'   → Render del layout principal (Header + Sidebar + main).
//
// El ToastContainer se monta a nivel layout (no por vista) para que los
// mensajes del store de validación sigan visibles al navegar entre rutas.

import Router from 'preact-router'
import { html } from 'htm/preact'
import { useEffect, useState } from 'preact/hooks'

import {
  initAuth,
  isAuthorized,
  getActiveAccount,
  subscribeAuthChange
} from './auth/auth-provider.js'

import { Header } from './components/Header.js'
import { Sidebar } from './components/Sidebar.js'
import { HomeView } from './components/HomeView.js'
import { InventoryView } from './components/InventoryView.js'
import { ClientView } from './components/ClientView.js'
import { IndicatorsView } from './components/IndicatorsView.js'
import { LoginScreen } from './components/LoginScreen.js'
import { UnauthorizedScreen } from './components/UnauthorizedScreen.js'
import { LoadingScreen } from './components/LoadingScreen.js'
import { ToastContainer } from './components/Toast.js'

export function App() {
  const [authState, setAuthState] = useState('loading')
  const [user, setUser] = useState(null)

  useEffect(() => {
    let cancelled = false

    const applyAccount = (account) => {
      if (cancelled) return
      if (!account) {
        setUser(null)
        setAuthState('login')
        return
      }
      if (!isAuthorized(account)) {
        setUser(account)
        setAuthState('unauthorized')
        return
      }
      setUser(account)
      setAuthState('authorized')
    }

    initAuth()
      .then(applyAccount)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[JMA AFAC] Error en initAuth:', err)
        if (!cancelled) setAuthState('login')
      })

    const unsubscribe = subscribeAuthChange(() => {
      applyAccount(getActiveAccount())
    })

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  if (authState === 'loading') {
    return html`<${LoadingScreen} />`
  }
  if (authState === 'login') {
    return html`<${LoginScreen} />`
  }
  if (authState === 'unauthorized') {
    return html`<${UnauthorizedScreen} />`
  }

  return html`
    <div class="layout">
      <${Header} user=${user} />
      <${Sidebar} />
      <main class="layout__main">
        <div class="layout__main-inner">
          <${Router}>
            <${HomeView} path="/" />
            <${InventoryView} path="/inventario" />
            <${ClientView} path="/clientes" />
            <${ClientView} path="/clientes/:clienteId" />
            <${IndicatorsView} path="/indicadores" />
            <${HomeView} default />
          <//>
        </div>
      </main>
      <${ToastContainer} />
    </div>
  `
}
